import styles from '../../styles/common/table.scss';
import cx from 'classnames';
import { makeid } from '../../constants';
import { CDN_CLEARSAVE_URL } from '../homePage/experimental/bannerBlack';

interface Props {
  items: any[];
  onSort?: (key: string) => void;
}

const TableHead = ({ items, onSort }: Props) => (
  <div className="row">
    {items.map((item) => (
      <div
        className={cx(
          item.className,
          styles.header,
          'columns font--bold font--dark-grey text--sm lil-flex lil-items-center',
          styles.columns
        )}
        key={makeid()}
      >
        <span>{item.title}</span>
        {item.sortKey && (
          <img
            src={`${CDN_CLEARSAVE_URL}/clearsave/images/1658297288_arrow_grey.svg`}
            className="lil-cursor-pointer"
            width="15"
            style={{ height: '12px', marginLeft: '3px' }}
            onClick={() => onSort(item.sortKey)}
          />
        )}
      </div>
    ))}
  </div>
);

export default TableHead;



// WEBPACK FOOTER //
// ./components/search/tableHead.tsx